// extracted by mini-css-extract-plugin
module.exports = {"leftButton":"style_leftButton__lAv1N"};